import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { RouterService } from '../services/router.service';
import { ActivationEnd } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { ProfileService } from '../services/profile.service';
import { MediaObserver } from '@angular/flex-layout';
import { Menu } from '../adapters/menu';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

	@Input('bgcolor') bgcolor : string = 'default';

	@Input('forceColor') forceColor : boolean = false;

	username : string;

	homePath: string;


	photoUrl: string = "";

	urlLength : number = 10;

	get showBack() : boolean {

		return this.homePath && (this.urlLength > (this.homePath == '/' ? 0 : 1))
	}


	constructor(public authService: AuthService,
				public storageService: StorageService,
				private changeDetectorRef: ChangeDetectorRef,
				private routerService: RouterService,
				private profileService: ProfileService,
				private media: MediaObserver) {


		this.router.events.subscribe(event => {

			if (event instanceof ActivationEnd)
			{
				this.urlLength = event.snapshot.url.length;
			}
		});


		this.authService.userBS.subscribe(user => {

			if (user)
			{
				this.username = user.name || user.username;

				if (user.admin)
				{
					this.homePath = '/admin/';
				}
				else
				{
					this.homePath = '/';
				}
			}
		});
	}

	get router() {return this.routerService.router;}

	get xs() : boolean {
		return this.media.isActive('xs');
	}


	get uploading() {return this.profileService.uploading;}


	back() {

		if (this.showBack)
			this.routerService.back();
	}


	ngOnInit() {

		this.profileService.photoUrl.subscribe(url => {

			this.photoUrl = url;

			if (!this.changeDetectorRef['destroyed'])
				this.changeDetectorRef.detectChanges();
		});
	}


	openHome() {

		if (this.homePath)
			this.router.navigate([this.homePath]);
	}


	signOut() {

		this.authService.signOut();
	}



	menu(view: any) {

		Menu.popup({
			view: view,
			actions: ['Perfil ('+this.username+')', 'Salir'],
			cancelButtonText: "Cancelar"
		})
		.then(action => {

			if (action)
			{
				if (action.title == 'Perfil ('+this.username+')')
				{
					this.router.navigate([this.homePath+'profile'])
				}
				else if (action.title == 'Salir')
				{
					this.signOut();
				}
			}
		});
	}

}
